import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const facts = $$('.facts');

if (facts.length) {
  facts.forEach(fact => {
    const slider = new Swiperslider($('.facts__item-wrapper', fact), {
      container: fact,
      sliderOptions: {
        spaceBetween: 30,
        breakpoints: {
          // when window width is >= 768px
          768: {
            spaceBetween: 60,
          },
          1200: {
            spaceBetween: 30,
          },
          1440: {
            spaceBetween: 120,
          },
        },
      },
    });
    slider.init();
  });
}
